// HATEOAS Link helper - Get link to self for a given resource
export const getSelfFromResourceLinks = object => {
    const link = object._links.self;
    const regex = /\/api(.*)$/g;
    const match = regex.exec(link.href);
    const hashLink = match[1];
    return hashLink || '/404';
};

// TODO: refactor all rec. action link formatters to point to this function
export const getRecoveryActionLink = recoveryAction => {};

// TODO: refactor all abn. link formatters to point to this function
export const getAbnormalityLink = abnormality => {};
